// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2gZy5","productName":"Table_productName__NrT1X"};